import React, { useEffect } from 'react';
import { useDeploymentTracker } from './DeploymentTrackerContext';
import { DeploymentTrackerService } from '../Service/DeploymentTrackerService';

// This component initializes the deployment service with the context hooks
const DeploymentMonitorInitializer: React.FC = () => {
  const { startMonitoring, stopMonitoring } = useDeploymentTracker();
  
  useEffect(() => {
    // Get the singleton instance
    const deploymentService = DeploymentTrackerService.getInstance();
    
    // Register the callbacks from context
    deploymentService.registerCallbacks(startMonitoring, stopMonitoring);
    
    return () => {
      // Unregister on unmount
      deploymentService.registerCallbacks(() => {}, () => {});
    };
  }, [startMonitoring, stopMonitoring]);
  
  return null;
};

export default DeploymentMonitorInitializer;